export default __webpack_public_path__ + "static/article-1-f3cb2d7c47935dfc6d3a19e658b21595.png";